module.exports = __webpack_public_path__ + "static/media/startup_expertise4.eccfc334.svg";